import React, {useState, useEffect} from 'react';
import styles from './category.module.css';
import { axiosAuthFetch, axiosAuthFetchDelete } from '../../../helpers/apiActions/authFetch';
import { API_BASE_URL } from '../../../constants';
import Modal from 'react-bootstrap/Modal';
import Loader from '../../loader';

export default function HandleCategoriesForm() {
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);

    useEffect(() => {
        const getCategories = async () => {
            setIsLoading(true);
            setIsError(false);

            try {
                const response = await axiosAuthFetch(`${API_BASE_URL}/categories?populate=*&pagination[pageSize]=50`);
                console.log(response);

                const sortedCategories = response.data.sort((a, b) =>
                    a.attributes.place.localeCompare(b.attributes.place)
                );

                setCategories(sortedCategories);
            } catch (error) {
                console.error(error);
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        };

        getCategories();
    }, []);

    const handleDeleteCategory = async (id) => {
        try {
            await axiosAuthFetchDelete(`${API_BASE_URL}/categories/${id}`);
            setCategories(categories.filter(category => category.id !== id));
        } catch (error) {
            console.error(error);
        }
    };

    if (isLoading) {
        return <div><Loader /></div>;
    }

    if (isError) {
        return <div>Error loading categories. Please try again later.</div>;
    }

    return (
        <div className={styles.container1}>
            <div className={styles.header}>
                <h1>Kategorier</h1>
                <div className={styles.addButton} onClick={() => setShowAddModal(true)}>Legg til kategori</div>
            </div>
            <div className={styles.nb}>NB! Kategorier kan ikke ha mellomrom eller æ, ø, eller å. Bruk understrek for mellomrom, så ordner programmet
                dette i front-enden.
            </div>
            <div className={styles.cardsParent}>
                {categories.map(category => (
                    <div key={category.id} className={styles.card}>
                        <div className={styles.categoryName}>{category.attributes.place}</div>
                        <div className={styles.buttonsContainer}>
                            <div className={styles.editButton} onClick={() => { setSelectedCategory(category); setShowEditModal(true); }}>Rediger</div>
                            <div className={styles.deleteButton} onClick={() => handleDeleteCategory(category.id)}>Slett</div>
                        </div>
                    </div>
                ))}
            </div>
            <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Legg til kategori</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AddCategoryForm />
                </Modal.Body>
                <Modal.Footer>
                    <div className={styles.smalKnapp}>
                        <div className={styles.deleteButton} onClick={() => setShowAddModal(false)}>Lukk</div>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Rediger kategori</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedCategory && <EditCategoryForm category={selectedCategory} />}
                </Modal.Body>
                <Modal.Footer>
                    <div className={styles.smalKnapp}>
                        <div className={styles.deleteButton} onClick={() => setShowEditModal(false)}>Lukk</div>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
}


export function AddCategoryForm() {
    const [place, setPlace] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        try {
            await axiosAuthFetch(`${API_BASE_URL}/categories`, {
                data: {
                    place
                }
            }, 'POST');
            setIsLoading(false);
            alert('Kategori opprettet!')
            window.location.reload();
            // Eventuelt oppdater kategorilisten eller vis en suksessmelding
        } catch (error) {
            console.error(error);
        }
    };

    if(isLoading) {
        return(
            <div><Loader /></div>
        )
    }
    return (
        <form className={styles.form} onSubmit={handleSubmit}>
            <label>
                Navn:
                <input
                    type="text"
                    value={place}
                    onChange={(e) => setPlace(e.target.value)}
                    required
                />
            </label>
            <button type="submit" className={styles.submitButton}>Legg til</button>
        </form>
    );
}

export function EditCategoryForm({ category }) {
    const [place, setPlace] = useState(category.attributes.place);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);

        try {
            await axiosAuthFetch(`${API_BASE_URL}/categories/${category.id}`, {
                data: {
                    place
                }
            }, 'PUT');
            // Eventuelt oppdater kategorilisten eller vis en suksessmelding
            setLoading(false);
            alert('Kategori oppdatert!');
            window.location.reload();
        } catch (error) {
            console.error(error);
        }
    };

    if(loading) {
        return (<div><Loader /></div>)
    }

    return (
        <form className={styles.form} onSubmit={handleSubmit}>
            <label>
                Navn:
                <input
                    type="text"
                    value={place}
                    onChange={(e) => setPlace(e.target.value)}
                    required
                />
            </label>
            <button type="submit" className={styles.submitButton}>Oppdater</button>
        </form>
    );
}